module.exports = __webpack_public_path__ + "static/media/device_scan_tip.b26da30c.png";